import { styled } from '@material-ui/core/styles'

export const ErrorRoot = styled('div')(({ theme }) => ({
  background: theme.palette.error.light,
  padding: theme.spacing(1),
}))
